import React, { useEffect, useState } from "react";

export const isUploadImage = (src) => {
  if (!src) return false;
  try {
    const url = new URL(src, window.location.origin);
    return url.origin === window.location.origin && url.pathname.startsWith("/uploads/");
  } catch {
    return false;
  }
};

const SafeImage = ({ src, fallbackSrc = "", containerClassName = "", children, ...imageProps }) => {
  const [candidate, setCandidate] = useState("");
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    let active = true;
    const primary = src || fallbackSrc;
    setAvailable(false);
    setCandidate(primary || "");
    if (!primary) return () => { active = false; };

    if (!isUploadImage(primary)) {
      setAvailable(true);
      return () => { active = false; };
    }

    const uploadUrl = new URL(primary, window.location.origin);
    const filename = uploadUrl.pathname.split("/").pop();
    fetch(`/api/uploads/exists/${encodeURIComponent(filename)}`, { cache: "no-store" })
      .then(async (response) => {
        if (!active) return;
        const result = response.ok ? await response.json() : null;
        if (result?.data?.exists === true) {
          setAvailable(true);
        } else if (fallbackSrc && fallbackSrc !== primary) {
          setCandidate(fallbackSrc);
          setAvailable(true);
        }
      })
      .catch(() => {
        if (active && fallbackSrc && fallbackSrc !== primary) {
          setCandidate(fallbackSrc);
          setAvailable(true);
        }
      });

    return () => { active = false; };
  }, [src, fallbackSrc]);

  const handleError = () => {
    if (fallbackSrc && candidate !== fallbackSrc) {
      setCandidate(fallbackSrc);
      setAvailable(true);
    } else {
      setAvailable(false);
    }
  };

  if (!candidate || !available) return null;
  const image = <img {...imageProps} src={candidate} onError={handleError} />;
  return containerClassName ? <div className={containerClassName}>{image}{children}</div> : image;
};

export default SafeImage;
